<template>
  <v-container
    class="assets-view-container"
    fluid
  >
    <vault-assets-table
      :assets="assets"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { VaultAssetsTable } from '@/components/vault';

export default {
  name: 'Assets',
  components: {
    'vault-assets-table': VaultAssetsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.vaultAssetsStore.loading,
      assets: state => state.vaultAssetsStore.vaultAssets,
    }),
  },
  async mounted() {
    this.getVaultAssets();
  },

  beforeDestroy() {
    this.resetAsset();
  },

  methods: {
    ...mapActions(['getVaultAssets', 'resetAsset']),
  },
};
</script>


<style lang="scss" scoped>
.assets-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/vault/VaultAssets.vue